import { Injectable } from "@angular/core";
import { firstValueFrom, lastValueFrom } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IPC_CHANNEL } from "../../_offline/electron.constants";
import { AssetModuleBundleDbService } from "../database/asset-module-bundle-db.service";
import { environment } from "../../../environments/environment";
import { AssetModuleClient } from "../asset-module/asset-module-client.service";

@Injectable({
  providedIn: "root"
})
export class AssetModuleSyncService {
  private offlineApiUrl = environment.ASSET_MODULE_OFFLINE;
  private onlineApiUrl = environment.PROTECTED_URIS.ASSET_MODULE;

  constructor(
    private assetModuleBundleDbService: AssetModuleBundleDbService,
    private assetModuleClient: AssetModuleClient,
    private httpClient: HttpClient
  ) {}

  async pullFromServer(): Promise<void> {
    const blob = await firstValueFrom(this.httpClient.get(`${this.onlineApiUrl}/AssetData/export-tenant-data`, { responseType: "blob" }));
    await this.importLocalDB(blob);
    await this.updateBundleInfo();
  }

  async pushToServer(): Promise<void> {
    const sinceParam = await this.getSinceTimestampQuery();

    const blob = await firstValueFrom(
      this.httpClient.get(`${this.offlineApiUrl}/AssetData/export-tenant-data${sinceParam}`, { responseType: "blob" })
    );
    if (blob.size === 0) return;

    const formData = new FormData();
    formData.append("file", blob, "asset-module.db");

    await firstValueFrom(this.httpClient.post(`${this.onlineApiUrl}/AssetData/import-tenant-data`, formData));
  }

  private async importLocalDB(blob: Blob) {
    await lastValueFrom(this.assetModuleClient.deleteAssetDataBundle());
    const formData = new FormData();
    formData.append("file", blob, "asset-module.db");
    await firstValueFrom(this.httpClient.post(`${this.offlineApiUrl}/AssetData/import-tenant-data?readOnly=true`, formData));
  }

  private async updateBundleInfo() {
    await firstValueFrom(
      this.assetModuleBundleDbService.put({
        id: IPC_CHANNEL.ASSET_MODULE_BUNDLE.ID,
        lastSyncTimestamp: new Date().toISOString()
      })
    );
  }

  private async getSinceTimestampQuery() {
    const bundle = await firstValueFrom(this.assetModuleBundleDbService.get());
    const since = bundle?.lastSyncTimestamp;
    return since ? `?since=${encodeURIComponent(since)}` : "";
  }
}
